import { gql } from '@apollo/client';

export const getVignettesOrderCompletedCollection = gql`
	query getVignettesOrderCompletedCollection($lang: String) {
		vignettesOrderCompletedCollection(locale: $lang, limit: 1) {
			items {
                headline(locale: $lang)
                text(locale: $lang)
                orderOverview(locale: $lang)
                orderNumber(locale: $lang)
                contactText(locale: $lang) {
					json
				}
				paymentUpdatedContactText(locale: $lang) {
					json
				}
                priceDetails {
                    totalPriceHeadline
                    flexServiceHeadline
                    flexServiceLabel
                }
                backLinkText(locale: $lang)
                backLink(locale: $lang)
                teaserHeadline(locale: $lang)
                processingHeadline(locale: $lang)
                processingText(locale: $lang)
                productStatusDone(locale: $lang)
                productStatusPending(locale: $lang)
				productStatusCancelled(locale: $lang)
                updatedPaymentHeadline(locale: $lang)
                paymentUpdatedText(locale: $lang)
	            backToOverview(locale: $lang)
                teasers: teasersCollection(locale: $lang, limit: 4) {
                    items {
                        headline(locale: $lang)
                        content(locale: $lang) {
                            json
                        }
                        buttonLabel (locale: $lang)
                        buttonLink
                        image
                    }
                }
                oneCartCountries: oneCartCountriesCollection (locale: $lang, limit: 3){
                    items {
                      id {
                        landList
                      }
                      country(locale: $lang)
                    }
				}
				helpDrawers: helpDrawersCollection(locale: $lang, limit: 5) {
					items {
						id
						helpDrawerTitle(locale: $lang)
					}
				}
            }
        }
	}
`;
